import { render, staticRenderFns } from "./saveClone.vue?vue&type=template&id=ffaa8670&scoped=true&"
import script from "./saveClone.vue?vue&type=script&lang=js&"
export * from "./saveClone.vue?vue&type=script&lang=js&"
import style0 from "./saveClone.vue?vue&type=style&index=0&id=ffaa8670&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaa8670",
  null
  
)

export default component.exports